import { useRef, useState } from "react";

/** Retain a closing layer's payload until Radix finishes unmounting its content. */
export function useRetainedLayer<T>(value: T | null, securityKey: string) {
  const [retained, setRetained] = useState({ securityKey, value });
  if (retained.securityKey !== securityKey || (value !== null && retained.value !== value)) {
    setRetained({ securityKey, value });
  }
  const current = useRef({ value, securityKey, generation: 0 });
  if (current.current.value !== value || current.current.securityKey !== securityKey) {
    current.current = { value, securityKey, generation: current.current.generation + 1 };
  }
  const generation = current.current.generation;
  return {
    value: value ?? (retained.securityKey === securityKey ? retained.value : null),
    onExited: () => {
      if (current.current.value === null && current.current.securityKey === securityKey && current.current.generation === generation) {
        setRetained({ securityKey, value: null });
      }
    },
  };
}
